import AboutModal from './AboutModal.json';
import Buttons from './Buttons.json';
import CaptureViewportModal from './CaptureViewportModal.json';
import CineDialog from './CineDialog.json';
import Colormaps from './Colormaps.json';
import Common from './Common.json';
import ContextMenu from './ContextMenu.json';
import DataRow from './DataRow.json';
import DatePicker from './DatePicker.json';
import Dialog from './Dialog.json';
import ErrorBoundary from './ErrorBoundary.json';
import Header from './Header.json';
import Hps from './Hps.json';
import Local from './Local.json';
import MeasurementTable from './MeasurementTable.json';
import Modals from './Modals.json';
import Modes from './Modes.json';
import Notification from './Notification.json';
import Onboarding from './Onboarding.json';
import PanelSUV from './PanelSUV.json';
import PatientInfo from './PatientInfo.json';
import ROIThresholdConfiguration from './ROIThresholdConfiguration.json';
import SegmentationPanel from './SegmentationPanel.json';
import SidePanel from './SidePanel.json';
import StudyBrowser from './StudyBrowser.json';
import StudyList from './StudyList.json';
import ToolbarLayoutSelector from './ToolbarLayoutSelector.json';
import Tools from './Tools.json';
import USAnnotationPanel from './USAnnotationPanel.json';
import UserPreferencesModal from './UserPreferencesModal.json';
import ViewportDownloadForm from './ViewportDownloadForm.json';
import WindowLevelActionMenu from './WindowLevelActionMenu.json';

export default { 
  'fr': {
    AboutModal,
    Buttons,
    CaptureViewportModal,
    CineDialog,
    Colormaps,
    Common,
    ContextMenu,
    DataRow,
    DatePicker,
    Dialog,
    ErrorBoundary,
    Header,
    Hps,
    Local,
    MeasurementTable,
    Modals,
    Modes,
    Notification,
    Onboarding,
    PanelSUV,
    PatientInfo,
    ROIThresholdConfiguration,
    SegmentationPanel,
    SidePanel,
    StudyBrowser,
    StudyList,
    ToolbarLayoutSelector,
    Tools,
    USAnnotationPanel,
    UserPreferencesModal,
    ViewportDownloadForm,
    WindowLevelActionMenu,
  }
};
